module.exports = __webpack_public_path__ + "static/media/MaxBounty_Image_White.3115843f.png";